module.exports = __webpack_public_path__ + "img/star_light.f1f772d6.svg";